import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

export interface PlaceholderProps {
  /** Short label shown as headline */
  title: string;
  /** Short informative text shown below the title */
  message: string;
}

/**
 * Generic stand‑in that replaces a chart if the underlying feature is not
 * activated (e.g. because the PCS has no data for that metric yet).
 *
 * * Keeps exactly the same minimum height as a chart (min‑h-[400px]) so the
 *   surrounding layout does not shift.
 * * Uses a dashed border & neutral colours to make it obvious that this is not
 *   an error, but rather an optional, unlockable feature.
 * * Gives a gentle nudge to the user to configure / provide the data without
 *   blocking the rest of the UI.
 */
export const Placeholder: React.FC<PlaceholderProps> = ({ title, message }) => (
  <div className="flex min-h-[400px] w-full flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 p-8 text-center">
    <InformationCircleIcon className="mb-4 size-12 text-gray-400" />

    <h3 className="mb-2 text-lg font-medium text-gray-700">{title}</h3>
    <p className="max-w-md text-sm text-gray-500">{message}</p>
  </div>
);
